<script>
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBTabs,
  MDBTabNav,
  MDBTabContent,
  MDBTabItem,
  MDBTabPane,
  MDBBtn
} from "mdb-vue-ui-kit";
import Cleave from "vue-cleave-component";
import { scroller } from "vue-scrollto/src/scrollTo";
import clientConfig from '/src/config/client';
import { ref } from 'vue';
import { mapGetters, mapMutations } from "vuex";
import { mapFields } from "vuex-map-fields";

import LifetimeSliderInput from '@lifetime-gallagher/lifetime-slider-input'

export default {
  name: "DisclaimerAndAssumptionsPanel",

  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBTabs,
    MDBTabNav,
    MDBTabContent,
    MDBTabItem,
    MDBTabPane,
    MDBBtn,

    Cleave,
    LifetimeSliderInput
  },

  data() {
    return {
      clientConfig,
      activeTabId: "ex1-1",

      wageInflation: -1,
      priceInflation: -1,
      grossReturn: 0,
      feePercentageOnBalance: 0,
      feePercentageOnBalanceCapped: 0,
      feePercentageOnContributions: 0,
      userDefinedOption: '',

      formatOptions: {
        salary: {
          numeral: true,
          prefix: "$",
          //prefix: " p/a",
          //tailPrefix: true,
          numeralPositiveOnly: true,
          noImmediatePrefix: true,
          rawValueTrimPrefix: true,
          numeralIntegerScale: 9,
          numeralDecimalScale: 2
        },
        percentage: {
          numeral: true,
          prefix: " %",
          tailPrefix: true,
          numeralPositiveOnly: true,
          noImmediatePrefix: true,
          rawValueTrimPrefix: true,
          numeralIntegerScale: 2,
          numeralDecimalScale: 2
        },
        number: {
          numericOnly: true,
          blocks: [2]
        }
      },
    }
  },

  computed: {
    ...mapGetters([
      "debugMode",
      "lastUpdated",
      "lastActiveTab",
      "data"
    ]),
    
    ...mapFields([
      "isEditingAssumptions",
      "superEngineConfig",
    ]),

    filteredInvestmentOptions() {
      let options = [];
      for (const optionList in this.superEngineConfig.InvestmentOptions) {
        let option = this.superEngineConfig.InvestmentOptions[optionList];
        if (option.name.indexOf("User") === -1) {
          options.push(option);
        }
      }
      return options.reverse();
    },

    grossReturnMin() {
      let minValue = 1;
      for (const optionList in this.superEngineConfig.InvestmentOptions) {
        let option = this.superEngineConfig.InvestmentOptions[optionList];
        if (option.name.indexOf("User") === -1 && option.grossReturn < minValue) {
          minValue = option.grossReturn;
        }
      }
      return this.$x100(minValue);
    },

    grossReturnMax() {
      let maxValue = 0;
      for (const optionList in this.superEngineConfig.InvestmentOptions) {
        let option = this.superEngineConfig.InvestmentOptions[optionList];
        if (option.name.indexOf("User") === -1 && option.grossReturn > maxValue) {
          maxValue = option.grossReturn;
        }
      }
      return this.$x100(maxValue);
    },



    customInvestmentOption() {
      // return this.superEngineConfig.InvestmentOptions[
      //   'investmentOption_' + (Object.keys(this.superEngineConfig.InvestmentOptions).length - 1)
      // ];
      return this.superEngineConfig.InvestmentOptions['custom'];
    }
  },

  methods: {
    ...mapMutations(["setIsEditingAssumptions"]),

    triggerHeightCheck() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    },

    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ccApp");
      
      this.triggerHeightCheck();
      
      this.$gtag.event('click', {
        'event_category': 'navigation',
        'event_label': 'navigateTo' + tabNum,
        'value': 1
      });
      
      if (this.debugMode)
        console.log("GTAG Event: navigateTo" + tabNum);
    },

    setCustomValuesFromPreset(event) {
      const selectedInvestmentOption = event.target.options[event.target.options.selectedIndex];
      if (event.target.options.selectedIndex > 0) {
        this.grossReturn = this.$x100(selectedInvestmentOption.getAttribute('data-grossreturn'));
        this.feePercentageOnBalance = this.$x100(selectedInvestmentOption.getAttribute('data-feepercentageonbalance'));
        this.feePercentageOnBalanceCapped = this.$x100(selectedInvestmentOption.getAttribute('data-feepercentageonbalancecapped'));
        this.feePercentageOnContributions = this.$x100(selectedInvestmentOption.getAttribute('data-feepercentageoncontributions'));

        this.superEngineConfig.InvestmentOption = Object.keys(this.superEngineConfig.InvestmentOptions).length;
        this.superEngineConfig.InvestmentOptionInRetirement = Object.keys(this.superEngineConfig.InvestmentOptions).length;
        this.superEngineConfig.InvestmentOption_2 = Object.keys(this.superEngineConfig.InvestmentOptions).length;
        this.superEngineConfig.InvestmentOptionInRetirement_2 = Object.keys(this.superEngineConfig.InvestmentOptions).length;

      } else {
        this.superEngineConfig.InvestmentOption = this.data.DefaultInvestmentOption;
        this.superEngineConfig.InvestmentOptionInRetirement = this.data.DefaultInvestmentOptionInRetirement;
        this.superEngineConfig.InvestmentOption_2 = this.data.DefaultInvestmentOption;
        this.superEngineConfig.InvestmentOptionInRetirement_2 = this.data.DefaultInvestmentOptionInRetirement;
      }
    },

    calculateClosestTaxableIncome(grossReturn) {
      let taxableIncome = 1;
      let calculatedMultiplier = 0;

      for (const optionList in this.superEngineConfig.InvestmentOptions) {
        let option = this.superEngineConfig.InvestmentOptions[optionList];
        if (option.name.indexOf("User") === -1) {
          if (grossReturn <= option.grossReturn) {
            calculatedMultiplier = option.taxableFraction / option.grossReturn;
            taxableIncome = Math.floor((grossReturn * calculatedMultiplier) * 10000) / 10000;
            break;
          }
        }
      }
      return taxableIncome;
    },

    enforceFieldMinMax(event, customUpdateObj = false) {
      const min = parseFloat(event.target.min);
      const max = parseFloat(event.target.max);
      if (customUpdateObj && customUpdateObj === 'superEngineConfig') {
        let fieldName = event.target.name.replace(/\w\S*/g, (f) => { return f.charAt(0).toUpperCase() + f.substr(1) });
        if (this.superEngineConfig[fieldName] < min) {
          this.superEngineConfig[fieldName] = min;
        } else if (this.superEngineConfig[fieldName] > max) {
          this.superEngineConfig[fieldName] = max;
        }
      } else if (customUpdateObj && customUpdateObj === 'customInvestmentOption') {
        if (this.customInvestmentOption[event.target.name] < min) {
          this.customInvestmentOption[event.target.name] = min;
        } else if (this.customInvestmentOption[event.target.name] > max) {
          this.customInvestmentOption[event.target.name] = max;
        }
      } else {
        if (this[event.target.name] < min) {
          this[event.target.name] = min;
        } else if (this[event.target.name] > max) {
          this[event.target.name] = max;
        }
      }
    }
  },

  watch: {
    isEditingAssumptions() {
      this.activeTabId = this.isEditingAssumptions ? ref("ex1-2") : ref("ex1-1");
    },

    wageInflation(newVal, oldVal) {
      if (oldVal >= 0) {
        this.superEngineConfig.WageInflationIndex[0] = this.$div100(newVal);
      }
    },

    priceInflation(newVal, oldVal) {
      if (oldVal >= 0) {
        this.superEngineConfig.PriceInflationIndex[0] = this.$div100(newVal);
      }
    },

    grossReturn(newVal) {
      this.customInvestmentOption.grossReturn = this.$div100(newVal);
      this.customInvestmentOption.taxableFraction = this.calculateClosestTaxableIncome(this.customInvestmentOption.grossReturn);
    },

    feePercentageOnBalance(newVal) {
      this.customInvestmentOption.feePercentageOnBalance = this.$div100(newVal);
    },

    feePercentageOnBalanceCapped(newVal) {
      this.customInvestmentOption.feePercentageOnBalanceCapped = this.$div100(newVal);
    },

    feePercentageOnContributions(newVal) {
      this.customInvestmentOption.feePercentageOnContributions = this.$div100(newVal);
    },
    
  },

  mounted() {
    this.wageInflation = this.$x100(this.superEngineConfig.WageInflationIndex[0]);
    this.priceInflation = this.$x100(this.superEngineConfig.PriceInflationIndex[0]);
  }
};
</script>

<template>
  <MDBContainer fluid>
    <MDBRow class="p-0">
      <MDBCol 
        md="11"
        class="main-content-wrapper"
      >
        <MDBRow>
          <MDBCol
            class="mx-auto"
          >
            <MDBTabs v-model="activeTabId">
              <MDBTabNav tabsClasses="mb-3">
                <MDBTabItem tabId="ex1-1" href="ex1-1" @click="setIsEditingAssumptions(false)">
                  {{ clientConfig.content.disclaimer.disclaimerTabText }}
                </MDBTabItem>
                <MDBTabItem tabId="ex1-2" href="ex1-2">
                  {{ clientConfig.content.disclaimer.editAssumptionsTabText }}
                </MDBTabItem>
              </MDBTabNav>

              <MDBTabContent>
                <MDBTabPane tabId="ex1-1">
                  <MDBRow>
                    <MDBCol>
                      <div v-html="clientConfig.content.disclaimer.content"></div>
                      <div class="disclaimer">
                        Last Updated:
                        {{ clientConfig.lastUpdated }}
                      </div>
                    </MDBCol>  
                  </MDBRow>
                </MDBTabPane>

                <MDBTabPane tabId="ex1-2">
                  <h3 class="assumptions">
                    {{ clientConfig.content.disclaimer.editAssumptionsHeading }}
                  </h3>

                  <div class="assumptions-field">
                    <label class="as-label" for="retirement-age-input">
                      {{ clientConfig.content.disclaimer.retirementAgeLabel }}
                    </label>

                    <div class="inputs-wrapper">
                      <LifetimeSliderInput
                        :min="data.retirementAge.min"
                        :max="data.retirementAge.max"
                        :step="1"
                        v-model="superEngineConfig.RetirementAge"
                      />

                      <cleave
                        v-model="superEngineConfig.RetirementAge"
                        :options="formatOptions.number"
                        name="retirementAge"
                        type="text"
                        class="form-control mini-input edit-assumptions"
                        tabindex="0"
                        @change="enforceFieldMinMax($event, 'superEngineConfig')"
                        :min="data.retirementAge.min"
                        :max="data.retirementAge.max"
                      >
                      </cleave>
                    </div>
                  </div>

                  <div class="assumptions-field">
                    <label class="as-label" for="wage-inflation-input">
                      {{ clientConfig.content.disclaimer.wageInflationLabel }}
                    </label>

                    <div class="inputs-wrapper">
                      <LifetimeSliderInput
                        :min="data.wageInflation.min"
                        :max="data.wageInflation.max"
                        :step="0.5"
                        v-model="wageInflation"
                      />

                      <cleave
                        v-model="wageInflation"
                        :options="formatOptions.percentage"
                        name="wageInflation"
                        type="text"
                        class="form-control mini-input edit-assumptions"
                        tabindex="0"
                        @change="enforceFieldMinMax($event)"
                        :min="data.wageInflation.min"
                        :max="data.wageInflation.max"
                      >
                      </cleave>
                    </div>
                  </div>

                  <p class="as-description">
                    {{ clientConfig.content.disclaimer.wageInflationDescription }}
                  </p>

                  <div class="assumptions-field">
                    <label class="as-label" for="price-inflation-input">
                      {{ clientConfig.content.disclaimer.priceInflationLabel }}
                    </label>

                    <div class="inputs-wrapper">
                      <LifetimeSliderInput
                        :min="data.priceInflation.min"
                        :max="data.priceInflation.max"
                        :step="0.5"
                        v-model.number="priceInflation"
                      />

                      <cleave
                        v-model.number="priceInflation"
                        :options="formatOptions.percentage"
                        name="priceInflation"
                        type="text"
                        class="form-control mini-input edit-assumptions"
                        tabindex="0"
                        @change="enforceFieldMinMax($event)"
                        :min="data.priceInflation.min"
                        :max="data.priceInflation.max"
                      >
                      </cleave>
                    </div>
                  </div>

                  <div class="assumptions-field">
                    <label class="as-label" for="insurance-premium-input">
                      {{ clientConfig.content.disclaimer.insurancePremiumLabel }}
                    </label>

                    <div class="inputs-wrapper">
                      <LifetimeSliderInput
                        :min="data.insurancePremium.min"
                        :max="data.insurancePremium.max"
                        :step="1"
                        v-model.number="superEngineConfig.InsurancePremium"
                      />

                      <cleave
                        v-model.number="superEngineConfig.InsurancePremium"
                        :options="formatOptions.salary"
                        name="insurancePremium"
                        type="text"
                        class="form-control mini-input edit-assumptions"
                        tabindex="0"
                        @change="enforceFieldMinMax($event, 'superEngineConfig')"
                        :min="data.insurancePremium.min"
                        :max="data.insurancePremium.max"
                      >
                      </cleave>
                    </div>
                  </div>

                  <div class="assumptions-field">
                    <h3 class="assumptions">
                      {{ clientConfig.content.disclaimer.userDefinedInvestmentOptionLabel }}
                    </h3>
                  </div>

                  <div class="assumptions-field user">
                    <label class="as-label user" for="userDefinedOption">
                      {{ clientConfig.content.disclaimer.createUserDefinedInvestmentOptionLabel }}
                    </label>
                    <select
                      id="userDefinedOption"
                      class="form-control select user-select"
                      v-model="userDefinedOption"
                      @change="setCustomValuesFromPreset"
                    >
                      <option selected value="">--choose--</option>
                      <option
                        v-for="(option, index) in filteredInvestmentOptions"
                        :key="index"
                        :value="option.id"
                        :data-feeAnnualDollar="option.feeAnnualDollar"
                        :data-feePercentageOnBalance="option.feePercentageOnBalance"
                        :data-feePercentageOnBalanceCapped="option.feePercentageOnBalanceCapped"
                        :data-feePercentageOnBalanceCappedCap="option.feePercentageOnBalanceCappedCap"
                        :data-feePercentageOnContributions="option.feePercentageOnContributions"
                        :data-grossReturn="option.grossReturn"
                        :data-taxableFraction="option.taxableFraction"
                        :data-optionIndex="index"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </div>

                  <div v-if="userDefinedOption != ''">
                    <div class="assumptions-field">
                      <label class="as-label" for="gross-return-input">
                        {{ clientConfig.content.disclaimer.grossReturnLabel }}
                      </label>
                      <div class="inputs-wrapper">
                        <LifetimeSliderInput
                          :min="grossReturnMin"
                          :max="grossReturnMax"
                          :step="0.1"
                          v-model.number="grossReturn"
                        />

                        <cleave
                          v-model.number="grossReturn"
                          :options="formatOptions.percentage"
                          name="grossReturn"
                          type="text"
                          class="form-control mini-input edit-assumptions"
                          tabindex="0"
                          @change="enforceFieldMinMax($event)"
                          :min="grossReturnMin"
                          :max="grossReturnMax"
                        >
                        </cleave>
                      </div>
                    </div>

                    <div class="assumptions-field">
                      <label class="as-label" for="fee-percentage-input">
                        {{ clientConfig.content.disclaimer.feePercentageOnBalanceLabel }}
                      </label>

                      <div class="inputs-wrapper">
                        <LifetimeSliderInput
                          :min="data.feePercentageOnBalance.min"
                          :max="data.feePercentageOnBalance.max"
                          :step="0.01"
                          v-model.number="feePercentageOnBalance"
                        />

                        <cleave
                          v-model.number="feePercentageOnBalance"
                          :options="formatOptions.percentage"
                          name="feePercentageOnBalance"
                          type="text"
                          class="form-control mini-input edit-assumptions"
                          tabindex="0"
                          @change="enforceFieldMinMax($event)"
                          :min="data.feePercentageOnBalance.min"
                          :max="data.feePercentageOnBalance.max"
                        >
                        </cleave>
                      </div>
                    </div>

                    <div class="assumptions-field">
                      <label class="as-label" for="fee-percentage-capped-input">
                        {{ clientConfig.content.disclaimer.feePercentageOnBalanceCappedLabel }}
                      </label>

                      <div class="inputs-wrapper">
                        <LifetimeSliderInput
                          :min="data.feePercentageOnBalanceCapped.min"
                          :max="data.feePercentageOnBalanceCapped.max"
                          :step="0.01"
                          v-model.number="feePercentageOnBalanceCapped"
                        />

                        <cleave
                          v-model.number="feePercentageOnBalanceCapped"
                          :options="formatOptions.percentage"
                          name="feePercentageOnBalanceCapped"
                          type="text"
                          class="form-control mini-input edit-assumptions"
                          tabindex="0"
                          @change="enforceFieldMinMax($event)"
                          :min="data.feePercentageOnBalanceCapped.min"
                          :max="data.feePercentageOnBalanceCapped.max"
                        >
                        </cleave>
                      </div>
                    </div>

                    <div class="assumptions-field">
                      <label class="as-label" for="insurance-premium-input">
                        {{ clientConfig.content.disclaimer.feePercentageOnBalanceCappedCapLabel }}
                      </label>

                      <div class="inputs-wrapper">
                        <LifetimeSliderInput
                          :min="data.feePercentageOnBalanceCappedCap.min"
                          :max="data.feePercentageOnBalanceCappedCap.max"
                          :step="0.01"
                          v-model.number="customInvestmentOption.feePercentageOnBalanceCappedCap"
                        />

                        <cleave
                          v-model.number="customInvestmentOption.feePercentageOnBalanceCappedCap"
                          :options="formatOptions.salary"
                          name="feePercentageOnBalanceCappedCap"
                          type="text"
                          class="form-control mini-input edit-assumptions"
                          tabindex="0"
                          @change="enforceFieldMinMax($event, 'customInvestmentOption')"
                          :min="data.feePercentageOnBalanceCappedCap.min"
                          :max="data.feePercentageOnBalanceCappedCap.max"
                        >
                        </cleave>
                      </div>
                    </div>

                    <div class="assumptions-field">
                      <label class="as-label" for="fee-percentage-on-contr-input">
                        {{ clientConfig.content.disclaimer.feePercentageOnContributionsLabel }}
                      </label>

                      <div class="inputs-wrapper">
                        <LifetimeSliderInput
                          :min="data.feePercentageOnContributions.min"
                          :max="data.feePercentageOnContributions.max"
                          :step="0.01"
                          v-model.number="feePercentageOnContributions"
                        />

                        <cleave
                          v-model.number="feePercentageOnContributions"
                          :options="formatOptions.percentage"
                          name="feePercentageOnContributions"
                          type="text"
                          class="form-control mini-input edit-assumptions"
                          tabindex="0"
                          @change="enforceFieldMinMax($event)"
                          :min="data.feePercentageOnContributions.min"
                          :max="data.feePercentageOnContributions.max"
                        >
                        </cleave>
                      </div>
                    </div>

                    <div class="assumptions-field">
                      <label class="as-label" for="fee-annual-dollar-input">
                        {{ clientConfig.content.disclaimer.feeAnnualDollarLabel }}
                      </label>

                      <div class="inputs-wrapper">
                        <LifetimeSliderInput
                          :min="data.feeAnnualDollar.min"
                          :max="data.feeAnnualDollar.max"
                          :step="0.01"
                          v-model.number="customInvestmentOption.feeAnnualDollar"
                        />

                        <cleave
                          v-model.number="customInvestmentOption.feeAnnualDollar"
                          :options="formatOptions.salary"
                          name="feeAnnualDollar"
                          type="text"
                          class="form-control mini-input edit-assumptions"
                          tabindex="0"
                          @change="enforceFieldMinMax($event, 'customInvestmentOption')"
                          :min="data.feeAnnualDollar.min"
                          :max="data.feeAnnualDollar.max"
                        >
                        </cleave>
                      </div>
                    </div>
                  </div>
                </MDBTabPane>
              </MDBTabContent>
            </MDBTabs>

            <MDBRow>
              <MDBCol
                class="mx-auto text-center pt-3"
              >
                <MDBBtn 
                  outline="secondary" 
                  class="rounded me-2"
                  @click="clickToTab(lastActiveTab)"
                  aria-label="Back button"
                >
                  {{ clientConfig.content.disclaimer.backButtonLabel }}
                </MDBBtn>
              </MDBCol>
            </MDBRow>

            <!-- <div class="disclaimer-buttons">
              <MDBBtn
                color="primary"
                class="btn btn-primary teal"
                aria-label="Reset button"
              >
                Reset
              </MDBBtn>
              <MDBBtn
                color="primary"
                class="btn btn-primary"
                aria-label="Apply button"
              >
                Apply

                
              </MDBBtn>
            </div> -->
          </MDBCol>
        </MDBRow>

      </MDBCol>
    </MDBRow>
  </MDBContainer>
</template>
